import { Text } from '@latitude/text';
import { Tooltip } from '@latitude/tooltip';

export const CTCTooltip = ({
  children = 'What is a CTC?',
}: {
  children?: string;
}) => (
  <div className="w-fit">
    <Tooltip
      className="text-clip"
      text={
        <div className="flex flex-col items-start gap-3">
          <Text variant="bodyRegular">
            What is a certified true copy (CTC)?
          </Text>
          <Text color="muted">
            A copy of a document that has been verified as a true and accurate
            reproduction of the original.
          </Text>

          <div className="flex flex-col gap-sizing-sys-size-2">
            <Text variant="bodyRegular" className="text-color-ref-text-muted">
              If you cannot provide the original, a CTC must be certified by one
              of the following independent certifiers:
            </Text>

            {/* oxlint-disable-next-line @anchorage/tailwind/no-tailwind-important -- custom spacing tokens, not deduped */}
            <ul className="list-disc !pl-spacing-sys-spacing-20 !pt-spacing-sys-spacing-12">
              <li>
                <Text
                  variant="bodyRegular"
                  className="text-color-ref-text-muted"
                >
                  Notary public
                </Text>
              </li>
              <li>
                <Text
                  variant="bodyRegular"
                  className="text-color-ref-text-muted"
                >
                  Lawyer
                </Text>
              </li>
              <li>
                <Text
                  variant="bodyRegular"
                  className="text-color-ref-text-muted"
                >
                  Certified public or professional accountant
                </Text>
              </li>
              <li>
                <Text color="muted">Registered agent</Text>
              </li>
            </ul>
          </div>
        </div>
      }
    >
      <Text
        data-testid="ctc-tooltip-text"
        variant="captionRegular"
        color="info"
      >
        {children}
      </Text>
    </Tooltip>
  </div>
);
